<template>
    <div class="sellDataTime">
        <el-breadcrumb class="bread-nav" separator="/">
            <el-breadcrumb-item>首页</el-breadcrumb-item>
            <el-breadcrumb-item>销售业绩榜单</el-breadcrumb-item>
            <el-breadcrumb-item>数据截止日期</el-breadcrumb-item>
        </el-breadcrumb>
        <el-form :inline="true" ref="formData" class="exportProjectForm" :rules="validateRules" :model="formData" align="left">
            <el-form-item label="日期" prop="sellDataTime">
                <el-date-picker v-model="formData.sellDataTime" align="left" type="date" :editable="false" placeholder="选择日期" :picker-options="pickerOptions1" format="yyyy 年 MM 月 dd 日"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <!-- <el-button type="primary" @click="submitData('formData')">提交</el-button> -->
                <el-button @click="cancel">取消</el-button>
            </el-form-item>
        </el-form>
        <!--end-->
        <el-breadcrumb class="bread-nav" separator="/">
            <el-breadcrumb-item>首页</el-breadcrumb-item>
            <el-breadcrumb-item>销售业绩榜单</el-breadcrumb-item>
            <el-breadcrumb-item>激励语</el-breadcrumb-item>
        </el-breadcrumb>
        <el-tabs type="border-card" v-if="ajaxData">
          <el-tab-pane label="直客排名">
            <el-input class="input-box" v-model="ajaxData['zhike-selling']['text']" placeholder="请输入内容"></el-input>
          </el-tab-pane>
          <el-tab-pane label="渠道排名">
            <el-input  class="input-box" v-model="ajaxData['qudao-selling']['text']" placeholder="请输入内容"></el-input>
          </el-tab-pane>
          <el-tab-pane label="昨日之星-直客">
            <el-input  class="input-box" v-model="ajaxData['yesterdays-top-zhike']['text']" placeholder="请输入内容"></el-input>
          </el-tab-pane>
          <el-tab-pane label="昨日之星-渠道">
            <el-input  class="input-box" v-model="ajaxData['yesterdays-top-qudao']['text']" placeholder="请输入内容"></el-input>
          </el-tab-pane>
        </el-tabs>
        <el-button class="text-btn" @click="submitData('formData')" type="primary">提交</el-button>
    </div>
</template>
<script>
import CONFIG from "@/config/index.js";
import TOOL from "@/tool/index.js";
import router from "@/router/index.js";
export default {
  name: "SellDataTime",
  data() {
    return {
      formData: {
        sellDataTime: null
      },
      ajaxData: null,
      validateRules: {
        sellDataTime: [
          { required: true, type: "date", message: "请选择日期", trigger: "blur" }
        ]
      },
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            }
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            }
          }
        ]
      }
    };
  },
  mounted() {
    this._init();
  },
  methods: {
    _getProjectList() {
      let self = this;
      this.$http
        .get(
          CONFIG.HOST +
            "/salesList/getSalesList" +
            "?t=" +
            TOOL.getCurrentTime()
        )
        .then(
          response => {
            let result = response.body;
            if (result && result.status === 1) {
              let o = TOOL.formatObj(result.data);
              self.ajaxData = o["other-data"];
              self.formData.sellDataTime =
                o["other-data"]["zhike-selling"].date;
            } else {
              this.$notify.error({
                message: result.message
              });
            }
          },
          response => {
            console.log(response);
          }
        );
    },
    _confirmMessage(message, success = () => {}, cancel = () => {}) {
      this.$confirm(message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(success)
        .catch(cancel);
    },
    submitData(formName) {
      let tmpData = {
        "zhike-selling": {
          "text": null,
          "date": null
        },
        "qudao-selling": {
          "text": null,
          "date": null
        },
        "yesterdays-top-qudao": {
          "text": null,
          "date": null
        },
        "yesterdays-top-zhike": {
          "text": null,
          "date": null
        }
      };
      let submitDataTime = new Date(this.formData.sellDataTime).format("yyyy-MM-dd");
      for (let objItem in tmpData) {
        for (let item in tmpData[objItem]) {
          switch (item) {
            case "text":
              tmpData[objItem][item] = this.ajaxData[objItem][item];
              break;
            case "date":
              tmpData[objItem][item] = submitDataTime;
              break;
          }
        }
      }
      console.log(tmpData);
      this.updateData(
        {
          key: "other-data",
          value: JSON.stringify(tmpData)
        },
        () => {
          this.$notify.success({
            message: `数据截至日期更新成功：${submitDataTime}`
          });
        }
      );
    },
    updateData(data, callback) {
      this.$http.put(CONFIG.HOST + "/salesList/updateSale", data).then(
        response => {
          let result = response.body;
          if (result && result.status === 1) {
            callback();
          } else {
            this.$notify.error({
              message: result.message
            });
          }
        },
        response => {
          console.log(response);
        }
      );
    },
    cancel(){
      this.formData.sellDataTime = null;
    },
    _init() {
      this._getProjectList();
      Date.prototype.format = function(fmt) {
        var o = {
          "M+": this.getMonth() + 1, //月份
          "d+": this.getDate(), //日
          "h+": this.getHours(), //小时
          "m+": this.getMinutes(), //分
          "s+": this.getSeconds(), //秒
          "q+": Math.floor((this.getMonth() + 3) / 3), //季度
          S: this.getMilliseconds() //毫秒
        };
        if (/(y+)/.test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            (this.getFullYear() + "").substr(4 - RegExp.$1.length)
          );
        }
        for (var k in o) {
          if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(
              RegExp.$1,
              RegExp.$1.length == 1
                ? o[k]
                : ("00" + o[k]).substr(("" + o[k]).length)
            );
          }
        }
        return fmt;
      };
    }
  }
};
</script>
<style lang="less">
.sellDataTime {
  width: 98%;
  margin: 0 auto;
  .bread-nav {
    margin: 20px 0;
  }
  .exportProjectForm {
    text-align: left;
    .select-box {
      width: 220px;
    }
  }
  .input-box{
    width: 100%;
  }
  .text-btn{
    width: 100%;
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// DataTime.vue?727c8978